import {
  ActionType,
  AnalyticsEventData,
  ComponentType,
  identify,
  logEvent as logCbAnalytics,
} from '@cbhq/client-analytics';
import { DEFAULT_PAGE_KEY_REGEX } from './pageKeyRegex';

export const getIsLocalDev = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.hostname === 'localhost' || window.location.hostname.includes('-local');
};

export type AnalyticsEvent = {
  eventName: string;
  loggingId?: string;
};

const events = {
  // Add Liquidity Events
  AddLiquidityConfirm: {
    eventName: 'add_liquidity_confirmed',
    loggingId: 'a67a161b-8f13-49ca-a5e1-56801e17a42d',
  },
  AddLiquiditySuccess: {
    eventName: 'add_liquidity_success',
    loggingId: '9640ef15-cb18-4971-9bef-c5f9e34f6af8',
  },
  AddLiquidityError: {
    eventName: 'add_liquidity_error',
    loggingId: 'f1941de0-1847-484e-abd1-b9eef86da27f',
  },

  // Remove Liquidity Events
  RemoveLiquidityConfirm: {
    eventName: 'remove_liquidity_confirmed',
    loggingId: '83325985-5e62-4d89-b632-cbd852b150c3',
  },
  RemoveLiquiditySuccess: {
    eventName: 'remove_liquidity_success',
    loggingId: 'c4321857-5a80-4431-9c1e-cbe2631f6b49',
  },
  RemoveLiquidityError: {
    eventName: 'remove_liquidity_error',
    loggingId: 'fd16b762-3830-4a6a-be00-1b038f5bff77',
  },

  // Collect Fees Events
  CollectFeesConfirm: {
    eventName: 'collect_fees_confirmed',
    loggingId: '5abc74f0-022c-452d-86e0-70e5d5c65bcf',
  },
  CollectFeesSuccess: {
    eventName: 'collect_fees_success',
    loggingId: '601159ba-5760-40fe-a890-2daddfc6390f',
  },
  CollectFeesError: {
    eventName: 'collect_fees_error',
    loggingId: '35973729-f448-49d1-a0a2-a42c5be72acf',
  },

  // Swap Events
  SwapConfirm: {
    eventName: 'swap_confirmed',
    loggingId: '5ede9fb2-ff16-4077-96e9-89badd6a9d62',
  },
  SwapSuccess: {
    eventName: 'swap_success',
    loggingId: '96806436-830a-438c-a26d-72e449df1736',
  },
  SwapError: {
    eventName: 'swap_error',
    loggingId: '11e5c94d-1306-4e6a-bc03-425c0ac4874f',
  },

  // Accept Terms of Service
  AcceptTermsOfService: {
    eventName: 'accept_terms_of_service_button_clicked',
    loggingId: 'ac29a449-fca6-4a09-8b2c-14bfbd8394fd',
  },

  // OFAC modal
  OFACModalView: {
    eventName: 'ofac_modal_viewed',
    loggingId: '01a24483-ffcc-4266-818b-c9fc596e6675',
  },
};

const AnalyticsEvents: Readonly<Record<keyof typeof events, AnalyticsEvent>> = events;

const errorEvents = {};

const ErrorEvents: Readonly<Record<keyof typeof errorEvents, AnalyticsEvent>> = errorEvents;

// Use logEvent wrapper to attach environment and other custom event properties
function logEvent(eventName: string, eventData: AnalyticsEventData): void {
  if (getIsLocalDev()) {
    return;
  }

  let pageKey = 'unknown';
  if (typeof eventData.url === 'string') {
    for (const [key, regex] of Object.entries(DEFAULT_PAGE_KEY_REGEX)) {
      if (regex.test(eventData.url)) {
        pageKey = key;
        break;
      }
    }
  }

  logCbAnalytics(eventName, {
    ...eventData,
    pageKey,
    environment: String(process.env.NODE_ENV),
  });
}

export { ActionType, AnalyticsEvents, ComponentType, ErrorEvents, identify, logEvent };
